<div class="smart-responses-indicator">
  <span>{{ 'bcSmartResponses.smartResponseIndicator' | translate }}</span><span class="smart-responses-hot-key">{{ 'bcSmartResponses.smartResponseKey' | translate }}</span>
</div>
<div class="smart-responses" [ngClass]="{'responses-shown': isSmartResponsesActive, 'discussions-enabled': hasDiscussionsFeature}">
  <div class="smart-response-list-wrapper">
    <div class="smart-responses-loading" *ngIf="isSmartResponseLoading">
      <app-loading></app-loading>
    </div>
    <div #smartResponseCloseMessage class="smart-response-close-message" (keydown)="handleKeyDownCloseMessage($event)" (blur)="onBlur()" tabindex="0">
      <span>{{ 'bcSmartResponses.closeSmartResponseMessage' | translate }}</span><span class="smart-responses-hot-key">{{ 'bcSmartResponses.closeSmartResponseKey' | translate }}</span>
    </div>
    <div class="no-smart-responses" *ngIf="noSmartResponses">{{ 'bcSmartResponses.noResponseMessage' | translate }}</div>
    <ul class="smart-response-list">
      <li #smartResponseListElement class="responses" *ngFor="let smartResponse of smartResponses; let i=index"
          [ngClass]="{'selected-response': smartResponse.selected}"
          tabindex="{{i}}"
          (click)="onClick(smartResponse, $event, i)"
          (mousedown)="onMouseDown($event)"
          (keydown)="handleKeyDown(smartResponse, $event, i)"
          (blur)="onBlur()"
          (focus)="onFocus($event)">
        <div class="smart-response-text" data-ellipsis data-ellipsis-separator=" " [innerHTML]="smartResponse.safeText"></div>
      </li>
    </ul>
  </div>
</div>
